<template>
  <div>
    <div
      v-if="!loadingCharges && !loadingSetting"
      class="message"
      style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
    >
      <div style="font-size: 12px;" :style="{ color: 'black' }">
        <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
          <span style="line-height:15.36px;">
            <template v-if="currentLang == 'th'">
              === สรุปการสั่งซื้อ ===
              <br />
              <br />
              Shirt (L): 100 {{ $t(currencySign) }} <br />-----------------------------
              <br />
              💰ค่าสินค้า (ไม่รวมค่าส่ง) 100 {{ $t(currencySign) }}
              <br />-----------------------------
              <br />
            </template>
            <template v-else-if="currentLang == 'la'">
              === ສະຫຼຸບການສັ່ງຊື້ ===
              <br />
              <br />
              Shirt (L): 100 {{ $t(currencySign) }} <br />-----------------------------
              <br />
              💰ຄ່າສິນຄ້າ (ບໍ່ລວມຄ່າຂົນສົ່ງ) 100 {{ $t(currencySign) }}
              <br />-----------------------------
              <br />
            </template>
            <template v-else>
              === Order Summary ===
              <br />
              <br />
              Shirt (L): 100 {{ $t(currencySign) }} <br />-----------------------------
              <br />
              💰Total (not including shipping) 100 {{ $t(currencySign) }}
              <br />-----------------------------
              <br />
            </template>
            {{ $t('Shipping option') }}
            <br />
            <template v-for="(charge, cindex) in charges">
              <div v-if="charge[1]" :key="cindex">
                📦{{ $t(cindex) }}
                <template v-if="charge[0] > 0"
                  >+{{ charge[0] | decimalFormat }} {{ $t(currencySign) }}</template
                >
                <template v-else>{{ $t('Free') }}</template>
              </div>
            </template>
          </span>
        </div>
      </div>
      <div
        style="float:left;width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden"
      >
        <ul class="list-group list-group-flush" style="margin-bottom: 0px;">
          <li
            v-if="!is_hide_add_more_btn && !(!edit && !value[0].labels[currentLang])"
            class="list-group-item"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px"
          >
            <div
              class="form-inline form-control d-flex"
              :class="{ 'has-error': errors.has('addEditBtn') }"
              style="align-items: center;"
              v-if="edit"
            >
              <input
                type="text"
                maxlength="20"
                class="form-control ma-0"
                name="addEditBtn"
                :placeholder="$t('addmore')"
                v-model="value[0].labels[currentLang]"
                data-vv-name="addEditBtn"
                :data-vv-as="$t('addmore')"
              />
              <p class="text-error" v-if="errors.has('addEditBtn')">
                {{ errors.first('addEditBtn') }}
              </p>
              <v-btn
                fab
                flat
                icon
                class="extra-small ma-0 ml-2"
                color="primary"
                @click="value[0].labels[currentLang] = ''"
              >
                <i class="fas fa-close"></i>
              </v-btn>
            </div>
            <span style="color: #0084FF" v-else>{{ value[0].labels[currentLang] }}</span>
          </li>
          <li
            class="list-group-item"
            v-if="showTransfer && !(!edit && !value[1].labels[currentLang])"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px;border-top:1px solid #eee;"
          >
            <div
              class="form-inline form-control d-flex"
              :class="{ 'has-error': errors.has('submitBtn') }"
              style="align-items: center;"
              v-if="edit"
            >
              <input
                type="text"
                maxlength="20"
                class="form-control ma-0"
                name="submitBtn"
                :placeholder="$t('confirm_order')"
                v-model="value[1].labels[currentLang]"
                data-vv-name="submitBtn"
                :data-vv-as="$t('confirm_order')"
              />
              <p class="text-error" v-if="errors.has('submitBtn')">
                {{ errors.first('submitBtn') }}
              </p>
              <v-btn
                flat
                icon
                class="extra-small ma-0 ml-2"
                color="primary"
                @click="value[1].labels[currentLang] = ''"
              >
                <i class="fas fa-close"></i>
              </v-btn>
            </div>
            <span style="color: #0084FF" v-else>{{ value[1].labels[currentLang] }}</span>
          </li>
          <li
            class="list-group-item"
            v-if="showCredicard"
            style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 10px 15px;border-top:1px solid #eee;"
          >
            <span style="color: #0084FF" v-if="currentLang == 'th'">บัตรเครดิต</span>
            <span style="color: #0084FF" v-else-if="currentLang == 'la'">ບັດເຄດິດ</span>
            <span style="color: #0084FF" v-else>Credit Card</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: null
    },
    edit: {
      default: false
    },
    is_hide_add_more_btn: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      setting: 'setting',
      loadingSetting: 'getLoadingSetting',
      currentLang: 'currentLang',
      loadingCharges: 'getLoadingCharges',
      charges: 'getCharges',
      selectedBot: 'selectedBot'
    }),
    currencySign() {
      const vm = this
      if (vm.selectedBot.pageid) {
        if (vm.$store.state.poundCurrency.includes(vm.selectedBot.pageid)) {
          return 'Pound'
        } else if (vm.$store.state.usdCurrency.includes(vm.selectedBot.pageid)) {
          return 'USD'
        } else if (vm.$store.state.tkBangladeshCurrency.includes(vm.selectedBot.pageid)) {
          return 'BDT'
        }
      }
      return 'Baht'
    },
    showTransfer: function() {
      return this.loadingSetting
        ? false
        : this.setting['allowtransfer'] && this.setting['allowtransfer'].contentvalue
    },
    showCredicard: function() {
      return this.loadingSetting
        ? false
        : this.setting['allowcreditcard'] && this.setting['allowcreditcard'].contentvalue
    }
  }
}
</script>

<style scoped>
.form-inline {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/ViewCartSummaryViewer.vue